import React from 'react'

import {
  WppActionButton,
  WppButton,
  WppFileUpload,
  WppIconChevron,
  WppListItem,
  WppSelect,
  WppStep,
  WppStepper,
  WppTextareaInput,
  WppTopbar,
  WppTypography,
} from '@platform-ui-kit/components-library-react'
import { useTranslation } from 'react-i18next'

import styles from './FormPreview.module.scss'
import { PAGE_PREVIEW_ID } from '../consts'
import { getPreviewConfig } from '../get-preview-config'

export const FormPreview = () => {
  const { t } = useTranslation()
  const { formPreviewNavigation } = getPreviewConfig({ t })

  const selectOne: readonly string[] = [
    t('form.selectOne.commerceDirector'),
    t('form.selectOne.augmentedReality'),
    t('form.selectOne.commerceDirector1'),
    t('form.selectOne.augmentedReality1'),
    t('form.selectOne.commerceDirector2'),
    t('form.selectOne.augmentedReality2'),
    t('form.selectOne.commerceDirector3'),
    t('form.selectOne.augmentedReality3'),
  ]
  const selectTwo: readonly string[] = [
    t('form.selectTwo.bavBrandData'),
    t('form.selectTwo.voiceAssistant'),
    t('form.selectTwo.ameriLinkData1'),
    t('form.selectTwo.bavBrandData1'),
    t('form.selectTwo.voiceAssistant2'),
    t('form.selectTwo.ameriLinkData2'),
    t('form.selectTwo.voiceAssistant3'),
    t('form.selectTwo.ameriLinkData3'),
  ]
  const steps: readonly string[] = [
    t('form.steps.general'),
    t('form.steps.client'),
    t('form.steps.market'),
    t('form.steps.summary'),
    t('form.steps.problemSolved'),
    t('form.steps.reviewAndSave'),
  ]

  return (
    <div className={styles.root}>
      <div id={PAGE_PREVIEW_ID}>
        <WppTopbar
          value={formPreviewNavigation[1].value}
          navigation={formPreviewNavigation}
          className={styles.previewHeader}
        />

        <div className={styles.main}>
          <div>
            <WppActionButton variant="secondary">
              <WppIconChevron direction="left" slot="icon-start" style={{ color: 'var(--wpp-grey-color-800)' }} />
              <WppTypography type="s-body" style={{ color: 'var(--wpp-grey-color-800)' }}>
                {t('form.back')}
              </WppTypography>
            </WppActionButton>
          </div>

          <div className={styles.titleWrapper}>
            <WppTypography type="3xl-heading">{t('form.createNewProduct')}</WppTypography>

            <div className={styles.buttonsWrapper}>
              <WppActionButton>{t('form.cancel')}</WppActionButton>
              <WppButton variant="secondary">{t('form.back')}</WppButton>
              <WppButton>{t('form.next')}</WppButton>
            </div>
          </div>

          <div className={styles.wrapper}>
            <div className={styles.fullWidthStepper}>
              <WppStepper activeStep={4} orientation="horizontal" className={styles.stepper}>
                {steps.map(step => (
                  <WppStep key={`step-item-${step}`}>
                    <p slot="label" className={styles.text}>
                      {step}
                    </p>
                  </WppStep>
                ))}
              </WppStepper>
            </div>

            <div className={styles.page}>
              <WppTypography type="l-strong" style={{ marginBottom: 20 }}>
                {t('form.summary')}
              </WppTypography>

              <WppTextareaInput
                value={t('form.productDescriptionValue')}
                required
                charactersLimit={400}
                labelConfig={{ text: t('form.productDescription') }}
                style={{ marginBottom: 32 }}
              />

              <WppFileUpload>
                <WppTypography type="m-strong" slot="label" style={{ marginTop: 32, marginBottom: 16 }}>
                  {t('form.productVideo')}
                </WppTypography>
              </WppFileUpload>

              <WppTypography type="m-strong" style={{ marginTop: 32, marginBottom: 16 }}>
                {t('form.linkedProducts')}
              </WppTypography>

              <div className={styles.selectWrapper}>
                <WppSelect value={selectOne.slice(0, 4)} labelConfig={{ text: t('form.applications') }} type="multiple">
                  {selectOne.map(label => (
                    <WppListItem key={label} value={label} multiple>
                      <p slot="label">{label}</p>
                    </WppListItem>
                  ))}
                </WppSelect>
                <WppSelect value={selectTwo.slice(0, 5)} labelConfig={{ text: t('form.datasets') }} type="multiple">
                  {selectTwo.map(label => (
                    <WppListItem key={label} value={label} multiple>
                      <p slot="label">{label}</p>
                    </WppListItem>
                  ))}
                </WppSelect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
